<template>
    <div class="whole">
        <div class="export flex-align">
            <div class="wrap generate flex-align" v-if="downloadBtnType">
                <i class="el-icon-download" @click="getgenerate" v-if="reportStatus == 0"> 生成个人报告</i>
                <span v-if="reportStatus == 1"> 报告生成中 <i class="el-icon-loading"></i></span>
                <span v-if="reportStatus == 2"><i class="el-icon-success"
                        style="color:#01b78f;margin-right: 5px;"></i>报告已生成</span>
            </div>
            <el-select v-model="whole_termValue" :popper-append-to-body="false" placeholder="请选择" @change="termChange">
                <el-option v-for="(item, index) in whole_termList" :key="index" :label="item.termName" :value="item.key">
                </el-option>
            </el-select>
            <el-select v-model="reportValue" :popper-append-to-body="false" placeholder="请选择" @change="reportChange">
                <el-option v-for="item in reportList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
            <el-select v-model="monthValue" :popper-append-to-body="false" placeholder="请选择" @change="monthChange"
                v-if="isMonthReport">
                <el-option v-for="item in monthList" :key="item.create_at" :label="item.name" :value="item.id">
                </el-option>
            </el-select>
            <el-select v-model="weekValue" placeholder="请选择" @change="weekValTypeChange" v-if="isWeekReport">
                <el-option v-for="(item, index) in weekList" :key="index" :label="item.name" :value="item.id">
                </el-option>
            </el-select>
            <div class="wrap flex-align" @click="getbatchdownload('btn')" v-if="table_type == 2">
                <img src="../../assets/newReport/export.png" alt="">
                下载报告
            </div>
        </div>
        <div class="bgc">
            <div class="sel">
                <div class="selR flex-align-center">
                    <div class="label1">年级：</div>
                    <el-select v-model="value5" style="margin: 0 20px;" placeholder="请选择" @change="gradeChange">
                        <el-option v-for="item in options1" :key="item.name" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="selR flex-align-center">
                    <div class="label1"> 班级：</div>
                    <el-select v-model="value11" style="margin: 0 20px;" placeholder="请选择" @change="classChange">
                        <el-option v-for="item in options2" :key="item.name" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="selR flex-align-center">
                    <div class="label1 labelX">姓名：</div>
                    <el-input v-model="input" placeholder="输入学生姓名搜索"></el-input>
                    <el-button icon="el-icon-search" @click="getData" style="margin-left: 10px;">查询</el-button>
                    <el-button icon="el-icon-refresh" @click="refresh_condition" style="margin-left: 10px;">重置</el-button>
                </div>
            </div>
            <old_report_whole ref="old_report_whole" v-if="table_type == 1"></old_report_whole>
            <new_report_whole ref="new_report_whole" v-else :preview="isPreview"></new_report_whole>

        </div>
    </div>
</template>

<script>
import old_report_whole from './old_report_whole';
import new_report_whole from './new_report_whole';

/** 报告类型：月测 / 周测（与接口 examType 一致） */
const REPORT_MONTH = 4;
const REPORT_WEEK = 5;

export default {
    components: {
        old_report_whole,
        new_report_whole
    },
    data() {
        return {
            schoolName: '',
            tableData: [],
            loadInfo: '暂无数据',
            userId: [],
            username: [],
            className: [],
            options1: [],
            options2: [],
            value5: [],
            value5_name: '',
            value11: [],
            input: '',
            excellent_add_total: [],
            excellent_minus_total: [],
            good_total: [],
            improve_add_total: [],
            once: true,
            whole_termList: [],
            whole_termValue: '',
            termKey: null,
            currentTerm: '',
            orgId: '',
            teac_Grade_class: '',
            roleType: '',
            schoolIdArr: ['181166', '1176', '181095', '181165', '1172', '181164', '1175', '181097', '1154'],
            table_type: '',
            yanshiId: '',
            term_type: '',
            reportList: [],
            reportValue: null,
            reportType: '',
            monthValue: '',
            monthList: [],
            monthId: '',
            monthName: '',
            account: ['15011591969', '18910941882', '13261203686', '13661102615'],
            downloadBtnType: false,
            reportStatus: 0,
            time: null,
            weekValue: '',
            weekName: '',
            weekList: [],
            isPreview: false,
        };
    },
    computed: {
        routeSchoolId() {
            return this.$route.query.schoolId || this.$route.query.bindId || '';
        },
        isMonthReport() {
            return Number(this.reportValue) === REPORT_MONTH;
        },
        isWeekReport() {
            return Number(this.reportValue) === REPORT_WEEK;
        },
    },
    watch: {
        $route: {
            handler() {
                this.syncPreviewFlagFromRoute();
            },
            immediate: false,
            deep: false
        }
    },
    methods: {
        parsePreviewFlag(val) {
            return val === true || val === 'true' || val === 1 || val === '1';
        },
        syncPreviewFlagFromRoute() {
            const queryPreview = this.$route?.query?.preview;
            const paramsPreview = this.$route?.params?.preview;
            const rawPreview = queryPreview !== undefined ? queryPreview : paramsPreview;
            this.isPreview = this.parsePreviewFlag(rawPreview);
        },
        withPreview(data, options = {}) {
            const ignoreTableType = options.ignoreTableType === true;
            if (!this.isPreview) return data;
            if (ignoreTableType || String(this.table_type) === '2') {
                return { ...data, preview: true };
            }
            return data;
        },
        clearMonthFields() {
            this.monthList = [];
            this.monthValue = '';
            this.monthId = '';
            this.monthName = '';
        },
        clearWeekFields() {
            this.weekList = [];
            this.weekValue = '';
            this.weekName = '';
        },
        /** 子表 getParentData 最后一参：旧版表始终传 monthValue；新版月测传 month，其它传 week（沿用原逻辑） */
        getExamIdForChildTable() {
            if (String(this.table_type) === '1') {
                return this.monthValue;
            }
            return this.isMonthReport ? this.monthValue : this.weekValue;
        },
        setChildTableEmpty() {
            const oldRef = this.$refs.old_report_whole;
            const newRef = this.$refs.new_report_whole;
            if (String(this.table_type) === '1' && oldRef) {
                oldRef.tableData = [];
            } else if (newRef) {
                newRef.tableData = [];
            }
        },
        /**
         * 已测评的报告类型
         * @param {boolean} applyRouteQuery 为 true 时优先用路由 reportValue、其次 testType（兼容多角色跳转）
         */
        async getReportType(applyRouteQuery = true) {
            const schoolId = this.routeSchoolId;
            const termKey = this.termKey != null && this.termKey !== '' ? this.termKey : this.whole_termValue;
            if (!schoolId || termKey == null || termKey === '') {
                this.reportList = [];
                this.reportValue = null;
                return;
            }
            let data = {
                termKey,
                schoolId,
                classId: '',
            };
            if (this.isPreview) {
                data.preview = true;
            }
            try {
                const resData = await this.$Api.Report.getReportType(data);
                const list = (resData && resData.data) || [];
                if (list.length > 0) {
                    this.reportList = list.map(item => ({
                        value: item.type,
                        label: item.name
                    }));
                    const inList = (v) => this.reportList.some(t => t.value === v);
                    if (applyRouteQuery) {
                        const q = this.$route.query;
                        let preferred = null;
                        if (q.reportValue != null && q.reportValue !== '') {
                            preferred = Number(q.reportValue);
                        } else if (q.testType != null && q.testType !== '' && q.fromType == 'multiRole') {
                            preferred = Number(q.testType);
                        }
                        if (preferred != null && !isNaN(preferred) && inList(preferred)) {
                            this.reportValue = preferred;
                        } else if (this.reportValue != null && inList(this.reportValue)) {
                            // 保持当前
                        } else {
                            this.reportValue = this.reportList[0].value;
                        }
                    } else if (!inList(this.reportValue)) {
                        this.reportValue = this.reportList[0].value;
                    }
                } else {
                    this.reportList = [];
                    this.reportValue = null;
                }
            } catch (e) {
                this.reportList = [];
                this.reportValue = null;
            }
        },
        async getOrgId(val) {
            const data = { termKey: val };
            const resData = await this.$Api.Home.queryUserMaxOrg(data);
            const roles = resData.data.roles.map(item => item.id);
            this.yanshiId = resData.data.userId;
            const hasTwo = roles.includes(2);
            const hasThree = roles.includes(3);
            if (hasTwo && hasThree) {
                this.roleType = 3;
                this.getOrgInfoid();
                // this.orgId = resData.data.userId == 459894 ? 6760 : resData.data.orgId;
                // this.getGradeList();
            } else if (hasTwo) {
                this.roleType = 2;
                this.getTeacherClass(val);
            } else if (hasThree) {
                this.roleType = 3;
                this.getOrgInfoid();
                // this.orgId = resData.data.userId == 459894 ? 6760 : resData.data.orgId;
                // this.getGradeList();
            }
        },
        async getGradeList() {
            let data = {
                orgId: this.orgId,
                termKey: this.termKey,
                schoolId: this.routeSchoolId,
            };
            data = this.withPreview(data);
            const resData = await this.$Api.DataScreen.getGradeList(data);
            this.options1 = resData.data;
            if (this.options1.length !== 0) {
                this.value5 = this.options1[0].id;
                this.value5_name = this.options1[0].name;
                this.getClassList();
            }
        },
        async getClassList() {
            let data = {
                orgId: this.orgId,
                gradeId: this.value5,
                schoolId: this.routeSchoolId,
                termKey: this.termKey,
            };
            data = this.withPreview(data);
            const resData = await this.$Api.DataScreen.getClassList(data);
            this.options2 = resData.data;
            if (this.options2.length !== 0) {
                this.value11 = resData.data[0].id;
                this.getData();
            }
        },
        getData() {
            if (this.reportValue == null) {
                return;
            }
            if (this.isMonthReport && this.monthList.length === 0) {
                this.setChildTableEmpty();
                return;
            }
            const examId = this.getExamIdForChildTable();
            const parentArgs = [
                this.orgId, this.termKey, this.roleType, this.value5, this.value5_name, this.value11,
                this.input, this.whole_termValue, this.currentTerm, this.table_type, this.reportValue, examId
            ];
            this.$nextTick(() => {
                if (String(this.table_type) === '1') {
                    this.$refs.old_report_whole.getParentData(...parentArgs);
                } else {
                    this.$refs.new_report_whole.getParentData(...parentArgs);
                }
            });
        },
        async getIsNewDIm() {
            if (this.reportValue == null) {
                return;
            }
            let data = {
                termKey: this.termKey,
                schoolId: this.routeSchoolId,
                examType: this.reportValue
            };
            data = this.withPreview(data, { ignoreTableType: true });
            const resData = await this.$Api.DataScreen.getIsNewDIm(data);
            this.table_type = resData.data;
            if (this.isMonthReport) {
                this.getMonthTestList();
            } else if (this.isWeekReport) {
                this.table_type = 2;
                this.weekParticipation();
            }
        },
        gradeChange(val) {
            const index = this.options1.findIndex(item => item.id == val);
            this.value5_name = this.options1[index].name;
            if (this.roleType == 2) {
                this.options2 = [];
                this.orgId = '';
                this.value11 = '';
                const targetObject = this.options1.find(obj => obj.id === val);
                this.orgId = this.yanshiId == 459894 ? 6760 : targetObject.schoolOrgId;
                const filteredArray = this.teac_Grade_class.filter(obj => obj.grade === val);
                filteredArray.forEach(item => {
                    this.options2.push({
                        id: item.classId,
                        name: item.className,
                    });
                });
                this.value11 = this.options2[0].id;
                this.getData();
            } else {
                this.getClassList();
            }
        },
        classChange() {
            this.getData();
        },
        async refresh_condition() {
            this.value5 = '';
            this.value11 = '';
            this.input = '';
            this.whole_termValue = this.whole_termList[0].key;
            this.termKey = this.whole_termValue;
            this.currentTerm = this.whole_termList[0].termName;
            await this.getReportType(false);
            this.getData();
        },
        async getTermList() {
            try {
                const res = await this.$Api.DataScreen.queryTermList();
                this.whole_termList = res.data;
                const q = this.$route.query;
                if (q.fromType == 'multiRole' && q.type == 'school') {
                    if (q.date) {
                        this.whole_termValue = Number(q.date);
                        this.termKey = this.whole_termValue;
                        const index = this.whole_termList.findIndex(item => item.key == Number(q.date));
                        this.currentTerm = this.whole_termList[index].termName;
                        await this.getReportType(true);
                        await this.getIsNewDIm();
                        this.getOrgInfoid();
                    }
                } else if (q.fromType == 'multiRole' && q.type == 'class') {
                    this.whole_termValue = Number(q.date);
                    this.termKey = this.whole_termValue;
                    const index = this.whole_termList.findIndex(item => item.key == Number(q.date));
                    this.currentTerm = this.whole_termList[index].termName;
                    await this.getReportType(true);
                    await this.getIsNewDIm();
                    this.getOrgId(this.termKey);
                } else {
                    this.whole_termValue = this.whole_termList[0].key;
                    this.termKey = this.whole_termValue;
                    this.currentTerm = this.whole_termList[0].termName;
                    this.term_type = this.whole_termList[0].term;
                    await this.getReportType(true);
                    await this.getIsNewDIm();
                    this.getOrgId(this.termKey);
                }
            } catch (err) {
                console.log('err:', err);
            }
        },
        async termChange(val) {
            this.options1 = [];
            this.value5 = '';
            this.options2 = [];
            this.value11 = '';
            this.termKey = val;
            this.tableData = [];
            const index = this.whole_termList.findIndex(item => item.key == val);
            this.currentTerm = this.whole_termList[index].termName;
            this.term_type = this.whole_termList[index].term;
            this.clearMonthFields();
            await this.getReportType(false);
            await this.getIsNewDIm();
            const q = this.$route.query;
            if (q.fromType == 'multiRole' && q.type == 'school') {
                if (q.date) {
                    this.getOrgInfoid();
                }
            } else {
                this.getOrgId(val);
            }
        },
        async getTeacherClass(val) {
            let data = {
                termKey: val,
                schoolId: this.routeSchoolId
            };
            data = this.withPreview(data);
            const resData = await this.$Api.Report.getTeacherClass(data);
            this.teac_Grade_class = resData.data;
            const seen = {};
            resData.data.forEach(item => {
                if (!seen[item.grade]) {
                    this.options1.push({
                        id: item.grade,
                        orgId: item.orgId,
                        schoolOrgId: item.schoolOrgId,
                        name: this.teac_Grade(item.grade),
                    });
                    seen[item.grade] = true;
                }
            });
            this.orgId = this.yanshiId == 459894 ? 6760 : this.options1[0].schoolOrgId;
            this.value5 = this.options1[0].id;
            this.value5_name = this.options1[0].name;
            const filteredArray = this.teac_Grade_class.filter(obj => obj.grade === this.value5);
            filteredArray.forEach(item => {
                this.options2.push({
                    id: item.classId,
                    name: item.className,
                });
            });
            this.value11 = this.options2[0].id;
            this.getData();
        },
        teac_Grade(id) {
            const Gradelist = {
                '1': '一年级',
                '2': '二年级',
                '3': '三年级',
                '4': '四年级',
                '5': '五年级',
                '6': '六年级',
            };
            return Gradelist[id];
        },
        hide_school() {
            const sid = this.$route.query.schoolId;
            return this.schoolIdArr.includes(sid) && this.termKey == '20232';
        },
        async getOrgInfoid() {
            let data = {
                bindId: this.$route.query.schoolId,
                level: 5,
                termKey: this.termKey
            };
            data = this.withPreview(data);
            const resData = await this.$Api.DataScreen.getOrgInfo(data);
            this.orgId = this.yanshiId == 459894 ? 6760 : resData.data.id;
            this.getGradeList();
        },
        async reportChange(val) {
            if (val != REPORT_MONTH) {
                this.clearMonthFields();
            }
            if (val != REPORT_WEEK) {
                this.clearWeekFields();
            }
            await this.getIsNewDIm();
            if (val != REPORT_MONTH && val != REPORT_WEEK) {
                this.getData();
            }
        },
        monthChange(val) {
            this.monthValue = val;
            const row = this.monthList.find(item => item.id == val);
            if (row) this.monthName = row.name;
            this.getData();
        },
        getMonthTestList() {
            this.monthList = [];
            this.monthValue = '';
            let data = {
                schoolId: this.routeSchoolId,
                termKey: this.whole_termValue,
                examType: REPORT_MONTH,
            };
            data = this.withPreview(data);
            this.$Api.Report.getparticipationMonth(data)
                .then(res => {
                    if (res.data.length !== 0) {
                        this.monthList = res.data;
                        this.monthValue = this.monthList[0].id;
                        this.monthName = this.monthList[0].name;
                        this.getData();
                    } else {
                        this.setChildTableEmpty();
                    }
                })
                .catch(() => { });
        },
        async getbatchdownload(type) {
            let data = {
                schoolId: this.routeSchoolId,
                termIndex: this.whole_termValue,
                examType: this.reportValue,
                examId: this.reportValue == REPORT_MONTH ? this.monthValue : this.weekValue,
                version: 2,
                batch: true
            };
            data = this.withPreview(data);
            const resData = await this.$Api.Report.getbatchdownload(data);
            if (resData.data != null) {
                this.reportStatus = 2;
                if (this.time) {
                    clearInterval(this.time);
                }
                if (type == 'btn') window.open(resData.data);
            } else if (type == 'btn') {
                this.$message({
                    message: '报告生成中',
                    center: true,
                    offset: 70,
                });
            }
        },
        async getgenerate() {
            let data = {
                schoolId: this.routeSchoolId,
                termIndex: this.whole_termValue,
                examType: this.reportValue,
                examId: this.reportValue == REPORT_MONTH ? this.monthValue : this.weekValue,
                version: 2,
                batch: true
            };
            data = this.withPreview(data);
            const resData = await this.$Api.Report.getgenerate(data);
            if (resData.code == 200) {
                this.reportStatus = 1;
                this.time = setInterval(() => {
                    this.getbatchdownload('polling');
                }, 5000);
            }
        },
        async weekParticipation() {
            this.weekList = [];
            this.weekValue = '';
            let data = {
                schoolId: this.routeSchoolId,
                termKey: this.whole_termValue,
                examType: REPORT_WEEK,
            };
            data = this.withPreview(data);
            const resData = await this.$Api.Report.getparticipationWeek(data);
            if (resData.data.length !== 0) {
                this.weekList = resData.data;
                this.weekValue = this.weekList[0].id;
                this.weekName = this.weekList[0].name;
                this.getData();
            } else {
                this.setChildTableEmpty();
            }
        },
        weekValTypeChange(val) {
            this.weekValue = val;
            const value = this.weekList.find(item => item.id == val);
            if (value) this.weekName = value.name;
            this.getData();
        }
    },
    mounted() {
        this.syncPreviewFlagFromRoute();
        this.getTermList();
        this.schoolName = this.$route.query.schoolName;
        this.downloadBtnType = this.account.includes(sessionStorage.getItem('name'));
    },
};
</script>
<style lang="less" scoped>
@import url("./less/report_whole.less");
</style>
